import { RefreshViewModel } from './../../Models/refreshViewModel';
import { RequestCacheService } from '../request-cache/request-cache-service';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ServiceResult } from '../../shared/Infra/ServiceResult';
import { TServiceResult } from '../../shared/Infra/TServiceResult';
import { AppHelper } from '../../shared/appHelper/appHelper';
import { User } from '../../Models/user';
import { Password } from '../../Models/password';
import { ResetPass } from '../../Models/reset-pass';
import { Confirm } from '../../Models/confirm';
import { UnAuthorizedServiceResult } from '../../shared/Infra/un-authorized-service-result';
import { UnauthenticatedServiceResult } from '../../shared/Infra/un-authenticated-service-result';
import { TServicePagingResult } from '../../shared/Infra/TServicePagingResult';
import { TermFilter } from '../../shared/Infra/term-filter';
import { USERPROFILE } from '../../shared/data/user-profile';
import { Token } from '../../Models/token';
import { UserAddress } from '../../Models/user-address';
import { ServiceBase } from '../service-base/service-base';
import { LocalRepository } from '../data/repository/local-repository';
import { LoginViewModel } from '../../Models/login-view-model';
import { PermissionService } from './permission.service';
import { lockoutModle } from '../../Models/lockoutModel';

@Injectable()
export class SecurityService extends ServiceBase<any> {
  tokenUrl = `${AppHelper.SSoBaseUrl}token`;
  accountUrl = `${AppHelper.SSoApi}Account`;
  branchUrl = `${AppHelper.SSoApi}Branch`;
  userManagerUrl = `${AppHelper.SSoApi}UserManager`;
  datasecurityUrl = `${AppHelper.SSoApi}DataSecurity`;

  constructor(
    public http: HttpClient,
    private requestCacheService: RequestCacheService,
    private permissionService: PermissionService,
    repo: LocalRepository,
  ) {
    super("", http, repo);
  }

  changeCurrentBranch(layoutName: string): Promise<TServiceResult<Token>> {

    let url = this.accountUrl + '/ChangeCurrentBranch?layoutName=' + layoutName;
    let clientId = this.ClientId;
    if (clientId)
      url = url + '&clientId=' + clientId;
    return this.http
      .get<TServiceResult<string>>(url)
      .toPromise()
      .then((result: any) => {
        if (result.successful) {
          let token = result.returnValue as Token;
          if (token != null && token.access_token) {
            super.clearUserDataStored();
            this.Repository.setItem('access_token', token.access_token);
            this.Repository.setItem('expires_in', token.expires_in);
            this.Repository.setItem('refresh_token', token.refresh_token);

          }
          return new TServiceResult<Token>(true, 'موفقیت آمیز', null);
        }
        else {
          if (layoutName === AppHelper.homeLayout) {
            super.clearUserDataStored();
          }
          return new TServiceResult<Token>(false, 'خطا در اعتبارسنجی', null);
        }
      });
  }

  login(username: string, password: string, smsPassword: string): Observable<TServiceResult<Token>> {
    let isPassword = password != '' && password != null && password != undefined;
    let data = new HttpParams()
      .set('UserName', username)
      .set(isPassword ? 'password' : 'smsPassword', isPassword ? password : smsPassword)
      .set('grant_type', 'password');
    //let data = "UserName=" + username + "&Password=" + password + "&grant_type=password";
    //const data = new LoginViewModel(username,password,smsPassword);
    const uri = this.tokenUrl//`${this.accountUrl}/login`;
    return this.http.post(uri, data).pipe(
      map((response: any) => {
        // login successful if there's a jwt token in the response
        let token = response.returnValue ? response.returnValue : new Object();
        if (token.access_token) {
          // set token property
          //alert(this.token)
          // store username and jwt token in local storage to keep user logged in between page refreshes
          this.Repository.setItem('access_token', token.access_token);
          this.Repository.setItem('expires_in', token.expires_in);
          this.requestCacheService.clearRequestCache();
          this.permissionService.clearCaches();
          // return true to indicate successful login
          return new TServiceResult<Token>(true, 'موفقیت آمیز', null);
        } else {
          return new TServiceResult<Token>(false, response.response, null);
        }
      }),
      catchError(error => this.handleError(error))
    );
  }

  login2(username: string, password: string, smsPassword: string): Observable<TServiceResult<Token>> {
    const data = new LoginViewModel(username, password, smsPassword);
    const uri = `${this.accountUrl}/login`;
    data.clientId = this.ClientId;
    return this.http.post(uri, data).pipe(
      map((response: any) => {
        let token = response.returnValue ? response.returnValue : new Object();
        if (token.access_token) {
          this.Repository.setItem('access_token', token.access_token);
          this.Repository.setItem('expires_in', token.expires_in);
          this.Repository.setItem('refresh_token', token.refresh_token);
          this.requestCacheService.clearRequestCache();
          this.permissionService.clearCaches();
          return new TServiceResult<Token>(true, 'موفقیت آمیز', null);
        } else {
          return new TServiceResult<Token>(false, response.response, null);
        }
      }),
      catchError(error => this.handleError(error))
    );
  }

  // refreshToken(data: RefreshViewModel): Observable<TServiceResult<Token>> {
  //   const uri = `${this.accountUrl}/RefreshToken`;
  //   return this.http.post<ServiceResult>(uri, data).pipe(
  //     map((response: any) => {
  //       let token = response.returnValue ? response.returnValue : new Object();
  //       if (token.access_token) {
  //         this.Repository.setItem('access_token', token.access_token);
  //         this.Repository.setItem('expires_in', token.expires_in);
  //         this.Repository.setItem('refresh_token', token.refresh_token);
  //         this.requestCacheService.clearRequestCache();
  //         return new ServiceResult(true, 'موفقیت آمیز');
  //       } else {
  //         return new ServiceResult(false, response.response);
  //       }
  //     }),
  //     catchError(error => this.handleError(error))
  //   );
  // }

  logout(): Observable<ServiceResult> {
    return this.http.get(this.accountUrl + '/SignOut').pipe(
      map((response: any) => {
        let result = response;
        if (result.successful) {
          for (var key in USERPROFILE) {
            USERPROFILE[key] = null;
          }
          USERPROFILE['appName'] = 'niazmandan';
          super.clearUserDataStored();
          this.requestCacheService.clearRequestCache();
          this.permissionService.clearCaches();
          return new ServiceResult(true, 'عملیات با موفقیت انجام شد.');
        } else {
          this.handleError;
        }
      }),
      catchError(this.handleError)
    );
  }

  getUserProfile(): Observable<TServiceResult<User>> {
    return this.http.get<TServiceResult<User>>(this.accountUrl + '/GetPerson');
  }

  editUserProfile(data: User): Observable<ServiceResult> {
    let userProfile = {
      PersonId: data.id,
      PersonName: data.fName,
      PersonLastName: data.lName,
      PersonNationalCode: data.nationalCode,
      PersonIdentity: data.userName,
      PersonAddress: data.address,
      PersonEmail: data.email
    };
    return this.http.post<ServiceResult>(this.accountUrl + '/EditPerson', userProfile);
  }

  deleteUser(userId: string): Observable<ServiceResult> {
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    const httpOptions = {
      headers: headers
    };
    var body = 'userId=' + userId + '&appId=' + 1;
    return this.http.post(this.userManagerUrl + '/DeleteUser', body, httpOptions).pipe(
      map((response: any) => <ServiceResult>response),
      catchError(this.handleError)
    );
  }

  resetUserPasswordAdmin(data: Password, userId: string): Observable<ServiceResult> {
    let changePass = {
      UserName: userId,
      OldPassword: data.OldPassword,
      NewPassword: data.NewPassword,
      ConfirmPassword: data.ConfirmPassword,
      AppName: 'sayeh_ui'
    };
    return this.http.post(this.accountUrl + '/ResetPasswordAdmin', changePass).pipe(
      map(() => new ServiceResult(true, 'عملیات با موفقیت انجام شد.')),
      catchError(this.handleError)
    );
  }

  getUsers(): Observable<TServiceResult<User[]>> {
    return this.http.get<TServiceResult<User[]>>(this.accountUrl + '/GetUsers');
  }

  getUserById(id): Observable<TServiceResult<User>> {
    return this.http.get<TServiceResult<User>>(this.accountUrl + '/GetUserById?userId=' + id);
  }

  getUsersByFilter(term: TermFilter, lockOut: boolean): Observable<TServicePagingResult<User[]>> {
    return this.http.post<TServicePagingResult<User[]>>(`${this.accountUrl}/GetUsersByFilter?lockout=` + lockOut, term);
  }

  lockoutUser(lockModel: lockoutModle): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.accountUrl}/lockoutUser`, lockModel);
  }

  getInvitedUsersByFilter(term: TermFilter): Observable<TServicePagingResult<User[]>> {
    return this.http.post<TServicePagingResult<User[]>>(`${this.accountUrl}/GetInvitedUsersByFilter`,
      term);
  }

  getUserByPhoneNumber(phoneNumber: string): Observable<TServiceResult<User>> {
    return this.http.get<TServiceResult<User>>(this.userManagerUrl +
      '/GetUserByPhoneNumber?phoneNumber=' + phoneNumber);
  }

  addDataSecurity(userId: string): Observable<ServiceResult> {
    return this.http
      .get<ServiceResult>(`${this.datasecurityUrl}/AddDataSecurity?key=AspNetUsers&value=${userId}`);
  }

  registerUser(info): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.accountUrl + '/Register', info);
  }

  uploadImage(userImage: any): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.accountUrl + '/EditImageJson', userImage);
  }

  activeUser(userName): any {
    let body = {
      username: userName,
      appName: 'sayeh.ir'
    };
    return this.http.post(this.userManagerUrl + '/Active', body);
  }

  createVerifyCode(phoneNumber): Observable<ServiceResult> {
    return this.http.get<ServiceResult>(this.accountUrl + '/CreateVerifyCode?mobileNumber=' +
      phoneNumber,
      {
        headers: { 'client-cache': 'off' }
      });
  }

  resetPassword(phoneNumber, password: ResetPass): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.accountUrl + '/ResetPassword?username=' +
      phoneNumber, password);
  }

  changePassword(clientId: string, password: ResetPass): Observable<TServiceResult<Token>> {
    let model = {
      oldPassword: password.oldPassword,
      newPassword: password.newPassword,
      confirmPassword: password.confirmPassword,
      clientId: clientId
    }
    return this.http.post<TServiceResult<Token>>(this.accountUrl + '/ChangePassword', model);
  }

  createForgotCode(phoneNumber): Observable<ServiceResult> {
    return this.http.get<ServiceResult>(this.accountUrl + '/CreateForgotCode?mobileNumber=' + phoneNumber,
      {
        headers: { 'client-cache': 'off' }
      });
  }

  confirmCode(model: Confirm): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.accountUrl + '/ConfirmCode', model,
      {
        headers: { 'client-cache': 'off' }
      });
  }

  createTempPassword(mobileNumber: string): Observable<ServiceResult> {
    return this.http.get<ServiceResult>(this.accountUrl +
      '/CreateTempCode?mobileNumber=' + mobileNumber,
      {
        headers: { 'client-cache': 'off' }
      });
  }

  getUserStateByPhoneNumber(phoneNumber): Observable<TServiceResult<number>> {
    return this.http.get<TServiceResult<number>>(this.userManagerUrl +
      '/GetUserStateByPhoneNumber?phoneNumber=' + phoneNumber);
  }

  mightyRegister(mightyInfo): Observable<ServiceResult> {
    return this.http.post(this.accountUrl + '/MightyRegister', mightyInfo).pipe(
      map((response: any) => {
        let token = response.returnValue;
        if (token) {
          this.Repository.setItem('access_token', token.access_token);
          this.Repository.setItem('expires_in', token.expires_in);
        }

        return new ServiceResult(true, 'موفقیت آمیز');
      }),
      catchError(error => this.handleError(error))
    );
  }

  externalLogin(): void {
    window.location.href = this.accountUrl + '/ExternalLogin?provider=Google' +
      '&returnUrl=' + document.location.href;
  }

  externalLoginConfirmation(data): Observable<ServiceResult> {
    return this.http.get(this.accountUrl + '/ExternalLoginConfirmation?email=' +
      data.Email + '&phoneNumber=' + data.PhoneNumber, { withCredentials: true }).pipe(
        map((response: Response) => {
          // login successful if there's a jwt token in the response
          let token = response.json().returnValue.access_token;
          if (token) {
            // set token property
            // store username and jwt token in local storage to keep user logged in between page refreshes
            this.Repository.setItem('access_token', token.access_token);
            this.Repository.setItem('expires_in', token.expires_in);
            // return true to indicate successful login
            return new ServiceResult(true, 'موفقیت آمیز');
          } else {
            return new ServiceResult(false, 'خطا');
          }
        }),
        catchError(error => this.handleError(error))
      );
  }

  getExternalLoginToken() {
    return this.http.get(this.accountUrl + '/GetExternalLoginToken',
      { withCredentials: true }).pipe(
        map((response: any) => {
          // login successful if there's a jwt token in the response
          let token = response.access_token;
          if (token) {
            // set token property
            //alert(this.token)
            // store username and jwt token in local storage to keep user logged in between page refreshes
            this.Repository.setItem('access_token', token.access_token);
            this.Repository.setItem('expires_in', token.expires_in);
            // return true to indicate successful login
            return new ServiceResult(true, 'موفقیت آمیز');
          } else {
            return new ServiceResult(false, 'خطا');
          }
        }),
        catchError(error => this.handleError(error))
      );
  }

  private handleError(error: any): Promise<any> {
    var err = new ServiceResult(false,
      'عملیات با خطا مواجه شد، لطفا مراتب را به واحد پشتیبانی سامانه سایه اطلاع دهید.');
    if (error.status == 401) {
      err = new UnauthenticatedServiceResult(false, error);
    } else if (error.status == 403) {
      err = new UnAuthorizedServiceResult(false, error);
    } else if (error.status == 400 && error._body == 'Invalid username or password.' &&
      error.ok == false) {
      err = new ServiceResult(false, 'نام کاربری یا رمز عبور صحیح نیست.');
    }

    return Promise.resolve<ServiceResult>(err);
  }


  /**
   * GetUserAddresses
   */
  public getUserAddresses(): Observable<TServiceResult<UserAddress[]>> {
    return this.http.post<TServiceResult<UserAddress[]>>(this.userManagerUrl +
      '/GetMyAddresses', null);
  }

  public addUserAddress(userAddress: UserAddress): Observable<TServiceResult<number>> {
    return this.http.post<TServiceResult<number>>(this.userManagerUrl +
      '/UserAddress', userAddress);
  }

  public editUserAddress(userAddress: UserAddress): Observable<TServiceResult<number>> {
    return this.http.put<TServiceResult<number>>(this.userManagerUrl +
      '/UserAddress', userAddress);
  }

  public deleteUserAddress(addressId: number): Observable<ServiceResult> {
    return this.http.delete<ServiceResult>(this.userManagerUrl +
      `/DeleteUserAddress/${addressId}`);
  }
  public getUserCount(): Observable<TServiceResult<number>> {
    return this.http.post<TServiceResult<number>>(this.userManagerUrl +
      `/UserCounts`, null,
      {
        headers: { 'client-cache': 'on' }
      });
  }
}
